<template>
  <div class="icon-container">
    <v-dialog width="380" v-if="$store.state.loggedIn">
      <template v-slot:activator="{ on, attrs }">
        <div class="clickable-region" v-bind="attrs" v-on="on">
          <img class="icon" v-bind:src="require('../../assets/sidebar/logout.svg')" alt="" color="primary" v-bind="attrs" v-on="on" />
        </div>
      </template>
      <template v-slot:default="dialog">
        <div class="logout-screen">
          <div class="header">Logout</div>
          <div class="bottom-link-text">Are you sure you want to logout?</div>

          <div class="buttons">
            <v-btn class="cancel" elevation="2" @click="dialog.value = false" width="100px">Cancel</v-btn>
            <v-btn
              class="logout"
              elevation="2"
              @click="
                logout();
                dialog.value = false;
              "
              width="100px"
              color="primary"
              >Logout</v-btn
            >
          </div>
        </div>
      </template>
    </v-dialog>
    <img class="icon" @click="$router.push('login').catch((err) => {})" v-else v-bind:src="require('../../assets/sidebar/login.svg')" alt="" color="primary" />
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  setup() {},
  methods: {
    logout() {
      this.$toast.success("Logged out successfully!", { position: "bottom-right", timeout: 7500 });
      this.$store.state.loggedIn = false;
      this.$router.push("login");

      document.cookie = "sessionID  " + "=; Max-Age=0";
      this.$store.state.isAdmin = false;
      
      if (this.$store.state.pipelineHandler != null) {
        this.$store.state.pipelineHandler.resetEnvironment();
      }
    },
  },
});
</script>

<style scoped>
.icon-container {
  width: 100%;
  cursor: pointer;
  height: 60px;
}

.icon {
  width: 32px;
  height: 32px;
  margin-left: calc(50% - 32px / 2);
  margin-top: calc(50% - 32px );
}

.buttons {
  position: relative;
  top: 200px;
  right: 25px;
}

.cancel {
  position: relative;
  right: 180px;
}
.logout {
  position: relative;
  right: 40px;
  bottom: 35px;
}
.bottom-link-text {
  position: relative;

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  /* or 143% */

  text-align: center;
  width: 5000px;

  top: 140px;
  left: 55px;

  color: #808080;
}
.header {
  width: 380px;
  height: 100px;
  background-color: #5774e7;

  color: white;

  position: absolute;
  padding-top: 35px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
}

.logout-screen {
  background-color: white;
  width: 380px;
  height: 260px;
  box-shadow: 0px 2px 4px rgba(0, 41, 199, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  position: relative;
}

.icon-container:hover {
  transition: 0.3s ease;
  background-color: var(--sidebar-item-hover);
}
</style>
